import { ExperiencePerformanceTypes } from '@atlassian/ufo-experimental/experience-types';
import {
	type ExperienceData,
	type PageLoadExperienceData,
} from '@atlassian/ufo-experimental/types';

export const isInitialPageLoad = (data: ExperienceData | PageLoadExperienceData): boolean => {
	return (
		data.performanceType === ExperiencePerformanceTypes.PageLoad &&
		(data as PageLoadExperienceData).initial === true
	);
};
